import AccountDetail from './account-detail.vue'
import Newaccountform from './new_account_form.vue'
import VendorPermissions from './vendor-permissions.vue'
export default{
    Newaccountform,
    'account-detail': AccountDetail,
    'vendor-permissions': VendorPermissions
}